export default {"src":"/_next/static/media/white-blob.e0d4554d.svg","height":623,"width":540};